import styled from 'styled-components';

export const ReactDateRangeCalendarRoot = styled.div`
  .rdrCalendarWrapper {
    font-family: inherit;
    font-size: 0.75rem;
  }

  .rdrMonth {
    padding-bottom: 0.5rem;
  }

  .rdrMonthAndYearPickers select {
    font-family: inherit;
    color: var(--allie-color-primary-90);
  }

  .rdrDayToday .rdrDayNumber span:after {
    background: var(--allie-color-primary-main);
  }

  .rdrDayNumber span {
    color: var(--allie-color-primary-90);
  }

  .rdrDayPassive .rdrDayNumber span {
    color: var(--allie-color-neutral-30);
  }

  .rdrSelected {
    background: var(--allie-color-primary-main);
  }

  .rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
    color: var(--allie-color-white);
  }

  .rdrDayStartPreview,
  .rdrDayInPreview,
  .rdrDayEndPreview {
    border-color: var(--allie-color-primary-main);
  }
`;
